import { Module } from "vuex";
import { UserStore } from "../types/examInterface";
import http from "@/utils/request";
import { clearBrowserSessionData } from "@/utils/clientSession";

interface UserState {
  token: string;
  userData: UserStore; 
}

export const Users: Module<UserState, unknown> = {
  namespaced: true,
  state: () => ({
    token: "",
    userData: {} as UserStore,
  }),
  mutations: {
    setToken(state, token: string) {
      state.token = token;
    },
    clearToken(state) {
      state.token = "";
    },
    setUserData(state, data: UserStore) {
      state.userData = data;
    },
    clearUserData(state) {
      state.userData = {} as UserStore;
    },
  },
  actions: {
    updateUserData({ commit }, data: UserStore) {
      commit("setUserData", data);
    },
    login({ commit }, { token, userData }: { token: string; userData: UserStore }) {
      commit("setToken", token)
      commit("setUserData", userData)
      localStorage.setItem("token", token)
      localStorage.setItem('my-app-store', JSON.stringify({
        Users: { token, userData }
      }))
    },
    async logout({ commit, dispatch }) {
      try {
        if (localStorage.getItem("token")) {
          await http.post("/api/logout");
        }
      } catch (error) {
        console.error("Failed to invalidate server session during logout:", error);
      } finally {
        commit("clearToken");
        commit("clearUserData");
        await dispatch("Exam/finishExam", null, { root: true });
        commit("Range/clearIdRange", null, { root: true });
        commit("Practice/CLEAR_ALL", null, { root: true });
        clearBrowserSessionData();
      }
    },
  },
  getters: {
    getUserData(state): UserStore {
      return state.userData;
    },
    getToken(state): string {
      return state.token;
    },
    isLogin(state): boolean {
      return !!state.token;
    },
  },
};
